import '../styles/pages/AboutUs.scss';
import valid from '../assets/icons/fiability.svg'
import vector from '../assets/icons/pres.svg'
import handshake from '../assets/icons/pareteneriat.svg'
import history from '../assets/history.png'
import mission from '../assets/mission.png'
import owner from '../assets/owner.png'
import sauter from '../assets/sauterfathi.png'
import ellipse from '../assets/icons/ellipse1.png'
import certif from '../assets/certif-kern.png'
import balance1 from '../assets/icons/balance1.png'
import balance3 from '../assets/icons/balance2.png'
import balance2 from '../assets/icons/balance3.png'
import bgLogo from '../assets/logo1.svg'
import bgLogo2 from '../assets/logow.svg'
import { useTranslation } from 'react-i18next';

const AboutUs = () => {
    const { t } = useTranslation();
    
    return (
        <div className="AboutUs">
            
            {/* Owner Banner Section with Tailwind */}
            <div className="relative w-full max-w-7xl mx-auto px-4 mt-12 lg:mt-24">
                {/* Mobile Design - Vertical Card with Overlap */}
                <div className="lg:hidden flex flex-col max-w-md mx-auto relative mt-12">
                    {/* Top Image Section */}
                    <div className="w-full rounded-[40px] overflow-hidden shadow-lg relative z-10 mb-[-60px]">
                        <img 
                            src={owner} 
                            alt="Owner" 
                            className="w-full h-[400px] object-cover"
                        />
                    </div>
                    
                    {/* Bottom Blue Section - Overlapped by image */}
                    <div className="relative bg-primary w-full h-72 flex flex-col items-center justify-center p-8 pt-20 overflow-hidden rounded-[40px] shadow-lg">
                        {/* Concentric Circles Background - White with opacity */}
                        <div className="absolute inset-0 flex items-center justify-center">
                            <img 
                                src={bgLogo} 
                                alt="background logo" 
                                className="w-full h-full object-cover scale-125 opacity-30 brightness-0 invert"
                            />
                        </div>
                        
                        {/* Content */}
                        <div className="relative z-10 text-white text-center">
                            <h1 className="text-6xl font-extrabold mb-3 font-inter">+25</h1>
                            <p className="text-2xl leading-relaxed font-normal">
                                {t('about.title')}
                            </p>
                        </div>
                    </div>
                </div>

                {/* Desktop Design - Side by Side */}
                <div className="hidden lg:flex items-stretch h-[480px]">
                    {/* Left Blue Section with Concentric Circles */}
                    <div className="relative bg-primary w-1/2 flex flex-col items-start justify-end p-12 overflow-hidden rounded-[40px] shadow-lg z-0">
                        {/* Concentric Circles Background - White with opacity */}
                        <div className="absolute inset-0 flex items-center justify-center">
                            <img 
                                src={bgLogo} 
                                alt="background logo" 
                                className="w-full h-full object-cover scale-125 opacity-30 brightness-0 invert"
                            />
                        </div>
                        
                        {/* Content */}
                        <div className="relative z-10 text-white max-w-[300px] ml-6 mb-6">
                            <h1 className="text-7xl font-extrabold mb-4 font-inter">+25</h1>
                            <p className="text-3xl font-normal">
                                {t('about.title')}
                            </p>
                        </div>
                    </div>
                    
                    {/* Right Image Section - Overlapping */}
                    <div className="w-1/2 rounded-[40px] overflow-hidden shadow-lg -ml-16 z-10">
                        <img 
                            src={owner} 
                            alt="Owner" 
                            className="w-full h-full object-cover"
                        />
                    </div>
                </div>
            </div>
            {/* Services Section with Tailwind */}
            <div className="w-full max-w-7xl mx-auto px-4 md:my-14">
                <div className="grid grid-cols-1 max-md:px-6 md:grid-cols-3 gap-8">
                    {/* Reliability Card */}
                    <div className="bg-white rounded-3xl p-8 flex flex-col items-center text-center shadow-[0_10px_40px_-15px_rgba(0,0,0,0.2)] hover:shadow-[0_20px_50px_-15px_rgba(0,0,0,0.3)] transition-shadow">
                        <div className="w-20 h-20 mb-6 flex items-center justify-center bg-gray-50 rounded-full">
                            <img src={valid} alt="Reliability" className="w-12 h-12 object-contain" />
                        </div>
                        <h2 className="text-primary text-xl md:text-2xl font-meduim mb-2">
                            {t('about.reliability')}
                        </h2>
                        <p className="text-sm md:text-base leading-relaxed">
                            {t('about.reliabilityDesc')}
                        </p>
                    </div>

                    {/* Precision Card */}
                    <div className="bg-white rounded-3xl p-8 flex flex-col items-center text-center shadow-[0_10px_40px_-15px_rgba(0,0,0,0.2)] hover:shadow-[0_20px_50px_-15px_rgba(0,0,0,0.3)] transition-shadow">
                        <div className="w-20 h-20 mb-6 flex items-center justify-center bg-gray-50 rounded-full">
                            <img src={vector} alt="Precision" className="w-12 h-12  object-contain" />
                        </div>
                        <h2 className="text-primary text-xl md:text-2xl font-meduim mb-2">
                            {t('about.precision')}
                        </h2>
                        <p className="text-sm md:text-base leading-relaxed">
                            {t('about.precisionDesc')}
                        </p>
                    </div>

                    {/* Partnership Card */}
                    <div className="bg-white rounded-3xl p-8 flex flex-col items-center text-center shadow-[0_10px_40px_-15px_rgba(0,0,0,0.2)] hover:shadow-[0_20px_50px_-15px_rgba(0,0,0,0.3)] transition-shadow">
                        <div className="w-20 h-20 mb-6 flex items-center bg-gray-50 rounded-full justify-center">
                            <img src={handshake} alt="Partnership" className="w-12 h-12 object-contain" />
                        </div>
                        <h2 className="text-primary text-xl md:text-2xl font-meduim mb-2">
                            {t('about.partnership')}
                        </h2>
                        <p className="text-sm md:text-base leading-relaxed">
                            {t('about.partnershipDesc')}
                        </p>
                    </div>
                </div>
            </div>
            {/* Journey Section with Tailwind */}
            <div className="w-full max-w-7xl mx-auto px-4 my-8 md:my-20">
                <div className="grid grid-cols-1 lg:grid-cols-2 gap-6 md:gap-12 items-start">
                    {/* Left Side - Title and Image */}
                    <div className="flex flex-col">
                        <h2 className="text-2xl lg:text-[40px] md:mx-6 text-center px-8 md:px-20 font-bold text-gray-900 leading-tight mb-0 md:mb-20">
                            {t('about.journeyTitle')}
                        </h2>
                        
                        {/* Image with Background Logo - Centered - Hidden on mobile, shown on desktop */}
                        <div className="hidden lg:flex relative max-md:flex-2 items-center md:min-h-[250px] justify-center flex-1">
                            {/* Background Logo */}
                            <div className="absolute inset-0 flex items-center justify-center opacity-90">
                                <img 
                                    src={bgLogo2} 
                                    alt="background logo" 
                                    className="w-[800px] md:w-[500px] h-[800px] scale-125 md:h-[420px] object-contain opacity-10"
                                />
                            </div>
                            
                            {/* Sauter Image - Centered */}
                            <img 
                                src={sauter} 
                                alt='Sauter Partner' 
                                className="w-40 h-auto object-contain relative z-10"
                            />
                        </div>
                    </div>
                    
                    {/* Right Side - Text Content */}
                    <div className="space-y-6">
                        {/* Image Container with Background Circle */}
                        <div className="relative flex justify-start mb-8">
                            <div className="relative ">
                                {/* Light background circle */}
                                <div className="absolute inset-0 flex items-center justify-center -z-10">
                                    <div className="w-48 h-48 bg-gray-100 rounded-full opacity-50"></div>
                                </div>
                                
                            </div>
                        </div>
                        
                        {/* Text Content */}
                        <div className="space-y-6">
                            <p className="text-black text-sm md:text-[19px] font-normal leading-relaxed text-justify">
                                {t('about.journeyText1')}
                            </p>
                            <p className="text-black text-sm md:text-[19px] font-normal leading-relaxed text-justify">
                                {t('about.journeyText2')}
                            </p>
                        </div>
                    </div>
                    
                    {/* Image with Background Logo - Mobile only at bottom */}
                    <div className="lg:hidden relative flex items-center min-h-[250px] justify-center w-full">
                        {/* Background Logo */}
                        <div className="absolute inset-0 flex items-center justify-center opacity-90">
                            <img 
                                src={bgLogo2} 
                                alt="background logo" 
                                className="w-[600px] h-[600px] scale-125 object-contain opacity-10"
                            />
                        </div>
                        
                        {/* Sauter Image - Centered */}
                        <img 
                            src={sauter} 
                            alt='Sauter Partner' 
                            className="w-48 h-auto object-contain relative z-10"
                        />
                    </div>
                </div>
            </div>
            {/* Expertise Timeline Section with Tailwind */}
            <div className="flex items-start flex-col justify-start bg-white rounded-2xl my-4 w-[90%] min-h-[30vh] px-6 lg:px-12 py-4">
                <h2 className="text-black font-bold text-2xl lg:text-[40px] leading-[2.5rem] my-1 mb-2 lg:mb-4 max-w-xl">
                    {t('about.expertiseTitle')}
                </h2>
                <span className="font-inter text-sm lg:text-base max-w-xl mb-4 lg:mb-0">
                    {t('about.expertiseSubtitle')}
                </span>
                
                {/* Desktop Timeline */}
                <div className="hidden lg:block w-full relative py-12">
                    <div className="my-16 flex justify-center items-center relative h-[150px] w-full">
                        <div className="relative w-[70%] h-1 bg-primary flex justify-between items-center">
                            {/* Timeline Point - Start (1989) */}
                            <div className="relative flex flex-col items-center">
                                {/* Balance Image */}
                                <img 
                                    src={balance1} 
                                    alt='balance' 
                                    className="absolute top-0 -translate-x-3/4 translate-y-0"
                                    style={{ width: 'auto', height: '90px', maxWidth: 'none' }}
                                />
                                
                                {/* Diagram Object */}
                                <div className="absolute top-0 translate-x-0 -translate-y-[400%] w-[180px]">
                                    <img 
                                        className="absolute top-0 z-[2] w-full h-[19vh] -translate-y-[110%] translate-x-[20%] rounded-[15px]" 
                                        src={history} 
                                        alt='history' 
                                    />
                                    <div className="absolute top-0 left-0 w-full h-[19vh] bg-primary rounded-[20px] z-[1] -translate-y-[120%]"></div>
                                </div>
                                
                                {/* Connector */}
                                <div className="w-0 h-[42px] border-l-[3px] font-medium border-t-[3px] border-b-[3px] border-dashed border-primary z-[1] absolute top-full mt-1 after:content-[''] after:absolute after:-translate-x-[62.5%] after:translate-y-[500%] after:w-[10px] after:h-[10px] after:bg-primary after:rounded-full">
                                    <div className="absolute top-16 w-[170px]">
                                        <h1 className="m-0 text-primary text-2xl font-bold">1989</h1>
                                        <span className="text-base">{t('about.timeline1989')}</span>
                                    </div>
                                </div>
                                
                                <img src={ellipse} alt="start" className="w-5 h-5 z-[2]" />
                            </div>

                            {/* Timeline Point - Middle (2000) */}
                            <div className="relative flex flex-col items-center">
                                {/* Balance Image */}
                                <img 
                                    src={balance2} 
                                    alt='balance' 
                                    className="absolute top-0 -translate-x-28 -translate-y-full"
                                    style={{ width: 'auto', height: '90px', maxWidth: 'none' }}
                                />
                                
                                {/* Diagram Object */}
                                <div className="absolute top-0 translate-x-0 w-[180px]">
                                    <img 
                                        className="absolute top-0 z-[2] w-full h-[19vh] translate-y-[50%] translate-x-[20%] rounded-[15px]" 
                                        src={mission} 
                                        alt='mission' 
                                    />
                                    <div className="absolute top-0 left-0 w-full h-[19vh] bg-primary rounded-[20px] z-[1] translate-y-[40%]"></div>
                                </div>
                                
                                {/* Connector */}
                                <div className="w-0 h-[50px] border-l-[3px] border-t-[3px] border-b-[3px] font-medium border-dashed border-primary z-[1] absolute bottom-full mb-1 after:content-[''] after:absolute after:-translate-x-[62.5%] after:-translate-y-[200%] after:w-[10px] after:h-[10px] after:bg-primary after:rounded-full">
                                    <div className="absolute bottom-0 ml-4 w-[156px]">
                                        <h1 className="m-0 text-primary text-2xl font-bold">2000</h1>
                                        <span className="text-base">{t('about.timeline2000')}</span>
                                    </div>
                                </div>
                                
                                <img src={ellipse} alt="middle" className="w-5 h-5 z-[2]" />
                            </div>

                            {/* Timeline Point - End (2025) */}
                            <div className="relative flex flex-col items-center">
                                {/* Balance Image */}
                                <img 
                                    src={balance3} 
                                    alt='balance' 
                                    className="absolute top-0 -translate-x-3/4 translate-y-[20%]"
                                    style={{ width: 'auto', height: '90px', maxWidth: 'none' }}
                                />
                                
                                {/* Diagram Object */}
                                <div className="absolute top-0 translate-x-1/2 -translate-y-[400%] w-[180px]">
                                    <img 
                                        className="absolute top-0 z-[2] w-full h-[19vh] -translate-y-[130%] translate-x-[20%] rounded-[15px]" 
                                        src={certif} 
                                        alt='certif' 
                                    />
                                    <div className="absolute top-0 left-0 w-full h-[19vh] bg-primary rounded-[20px] z-[1] -translate-y-[120%]"></div>
                                </div>
                                
                                {/* Connector */}
                                <div className="w-0 h-[42px] border-l-[3px] border-t-[3px] font-medium border-b-[3px] border-dashed border-primary z-[1] absolute top-full mt-1 after:content-[''] after:absolute after:-translate-x-[62.5%] after:translate-y-[500%] after:w-[10px] after:h-[10px] after:bg-primary after:rounded-full">
                                    <div className="absolute top-5 ml-4 w-[156px]">
                                        <h1 className="m-0 text-primary text-2xl font-bold">2025</h1>
                                        <span className="text-base">{t('about.timeline2025')}</span>
                                    </div>
                                </div>
                                
                                <img src={ellipse} alt="end" className="w-5 h-5 z-[2]" />
                            </div>
                        </div>
                    </div>
                </div>

                {/* Mobile Timeline - Vertical */}
                <div className="lg:hidden w-full py-8">
                    <div className="relative flex flex-col items-center min-h-[600px]">
                        {/* Vertical Line */}
                        <div className="absolute left-1/2 top-0 bottom-0 w-1 bg-primary -translate-x-1/2"></div>
                        
                        {/* Top Circle Cap */}
                        <div className="absolute left-1/2 top-0 -translate-x-1/2 z-20">
                            <img src={ellipse} alt="start" className="w-5 h-5" />
                        </div>
                        
                        {/* Bottom Circle Cap */}
                        <div className="absolute left-1/2 bottom-0 -translate-x-1/2 z-20">
                            <img src={ellipse} alt="end" className="w-5 h-5" />
                        </div>

                        {/* Timeline Point 1 - 1989 (Left) - At Top */}
                        <div className="absolute top-0 w-full flex items-start">
                            {/* Left Content */}
                            <div className="w-1/2 -mt-14 pr-6 text-right">
                                {/* Balance Icon */}
                                <div className="flex justify-end mb-3">
                                    <img src={balance1} alt='balance' className="w-16 h-16 object-contain" />
                                </div>
                                <h3 className="text-primary text-start text-2xl font-bold mb-1">1989</h3>
                                <p className="text-sm text-start text-gray-700">{t('about.timeline1989')}</p>
                            </div>

                            {/* Center - Ellipse with dashed line to left */}
                            <div className="absolute left-1/2 top-0 -translate-x-1/2 z-10">
                                <img src={ellipse} alt="start" className="w-5 h-5" />
                                {/* Dashed line pointing left with dot on left end */}
                                <div className="absolute right-full top-1/2 -translate-y-1/2 flex items-center">
                                    <div className="w-2 h-2 bg-primary rounded-full mr-1"></div>
                                    <div className="w-16 h-0 border-t-2 border-dashed border-primary"></div>
                                </div>
                            </div>

                            {/* Right Image */}
                            <div className="w-1/2 pl-6">
                                <div className="relative">
                                    <div className="absolute inset-0 bg-primary rounded-[32px] -translate-x-1 translate-y-1"></div>
                                    <img 
                                        src={history} 
                                        alt='history' 
                                        className="relative z-10 w-full translate-x-2 translate-y-4  h-32 object-cover rounded-[32px]"
                                    />
                                </div>
                            </div>
                        </div>

                        {/* Timeline Point 2 - 2000 (Right) - Center */}
                        <div className="absolute top-1/2 -translate-y-1/2 w-full flex items-center">
                            {/* Left Image */}
                            <div className="w-1/2 pr-6">
                                <div className="relative">
                                    <div className="absolute inset-0 bg-primary rounded-[32px] translate-x-0 translate-y-1"></div>
                                    <img 
                                        src={mission} 
                                        alt='mission' 
                                        className="relative z-10 w-full h-32 object-cover translate-x-3 translate-y-4 rounded-[32px]"
                                    />
                                </div>
                            </div>

                            {/* Center - Ellipse with dashed line to right */}
                            <div className="absolute left-1/2 -translate-x-1/2 z-10">
                                <img src={ellipse} alt="middle" className="w-5 h-5" />
                                {/* Dashed line pointing right with dot on right end */}
                                <div className="absolute left-full top-1/2 -translate-y-1/2 flex items-center">
                                    <div className="w-16 h-0 border-t-2 border-dashed border-primary mr-1"></div>
                                    <div className="w-2 h-2 bg-primary rounded-full"></div>
                                </div>
                            </div>

                            {/* Right Content */}
                            <div className="w-1/2 pl-6 text-left">
                                {/* Balance Icon */}
                                <div className="flex justify-start mb-3 ml-6">
                                    <img src={balance2} alt='balance' className="w-16 h-16 object-contain" />
                                </div>
                                <h3 className="text-primary text-2xl font-bold mb-1">2000</h3>
                                <p className="text-sm text-gray-700">{t('about.timeline2000')}</p>
                            </div>
                        </div>

                        {/* Timeline Point 3 - 2025 (Left) - At Bottom */}
                        <div className="absolute bottom-0 w-full flex items-end">
                            {/* Left Content */}
                            <div className="w-1/2 pr-6 text-right -mb-20">
                                {/* Balance Icon */}
                                <div className="flex justify-end mb-3 ">
                                    <img src={balance3} alt='balance' className="w-16 h-16 object-contain " />
                                </div>
                                <h3 className="text-primary text-start ml-12 text-2xl font-bold mb-1">2025</h3>
                                <p className="text-sm text-start max-w-[70px] text-gray-700 ml-12">{t('about.timeline2025')}</p>
                            </div>

                            {/* Center - Ellipse with dashed line to left */}
                            <div className="absolute left-1/2 bottom-0 -translate-x-1/2 z-10">
                                <img src={ellipse} alt="end" className="w-5 h-5" />
                                {/* Dashed line pointing left with dot on left end */}
                                <div className="absolute right-full top-1/2 -translate-y-1/2 flex items-center">
                                    <div className="w-2 h-2 bg-primary rounded-full mr-1"></div>
                                    <div className="w-16 h-0 border-t-2 border-dashed border-primary"></div>
                                </div>
                            </div>

                            {/* Right Image */}
                            <div className="w-1/2 pl-6">
                                <div className="relative">
                                    <div className="absolute inset-0 bg-primary rounded-2xl -translate-x-1 translate-y-1"></div>
                                    <img 
                                        src={certif} 
                                        alt='certif' 
                                        className="relative z-10 w-full h-32 object-cover rounded-2xl"
                                    />
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default AboutUs;
